<template>
  <el-select
    v-model="value"
    filterable
    :loading="loading"
    :remote-method="getCpsApp"
    @change="changeCpsApp"
    placeholder="投放应用"
  >
    <el-option
      v-for="item in appNameOptions"
      :key="item.appId"
      :label="item.appName"
      :value="item.appId"
    />
  </el-select>
</template>

<script>
import { getCpsApp } from "@/api/manage/cps/cps";

export default {
  props: {
    modelValue: [String, Number, Boolean],
    appId: {
      type: Number,
      default: undefined,
    },
    checked: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changeCpsApp"],
  data() {
    return {
      appNameOptions: [],
      loading: false,
      value: undefined,
    };
  },
  created() {
    this.getCpsApp();
    console.log(this.value);
  },
  methods: {
    getCpsApp() {
      this.loading = true;
      getCpsApp().then((res) => {
        if (res.code === 200) {
          this.appNameOptions = res.data;
          if (this.checked) {
            this.value = this.appNameOptions[0].appId;
            this.changeCpsApp();
          }
        }
      });
      this.loading = false;
    },
    changeCpsApp() {
      this.$emit("changeCpsApp", { appId: this.value });
    },
  },
};
</script>

<style scoped></style>
